import { useSelector } from 'react-redux';
import { GlobalState } from '../../../../../../store/types';
import './style.scss';

import minus from '../../../../../../assets/minus.svg';

type Props = {
  title: string;
  subtitle: string;
  toggleChat: () => void;
  showCloseButton: boolean;
  titleAvatar?: string;
  fullScreenMode: boolean;
  /** Suppress the channel logo; the bar collapses with it only in full screen — see below (IMBEE-9667). */
  hideHeader?: boolean;
};

function Header({ title, subtitle, toggleChat, showCloseButton, titleAvatar, fullScreenMode, hideHeader }: Props) {
  const parentUrl = useSelector((state: GlobalState) => state.responses.parentUrl);
  /**
   * `hideHeader` suppresses the channel logo everywhere, and drops the whole bar only where
   * dropping it costs nothing.
   *
   * In full screen the bar carries the logo and nothing else — the close button is already
   * suppressed because the host app supplies its own navigation — so collapsing it is the whole
   * point of the parameter.
   *
   * On a website embed the bar also carries the close button, and on a mobile device that button
   * is the ONLY way out: `layout.tsx` deliberately does not render the launcher while the chat is
   * open on mobile, because an open chat is full-screen there and a floating bubble over it makes
   * no sense. Removing the bar in that context leaves the visitor with no way to close the widget
   * at all. `isMobile` comes from react-device-detect and is USER-AGENT based, so resizing a
   * desktop browser cannot reproduce it — the launcher renders and the case looks fine.
   *
   * So: logo hidden in both, bar dropped only in full screen.
   */
  const headerAvatar = hideHeader ? '' : titleAvatar;
  const dropBar = Boolean(hideHeader) && fullScreenMode;
  const renderHeader = !dropBar && ((showCloseButton && !fullScreenMode) || !!headerAvatar || !!subtitle);
  return renderHeader ? (
    <div className="rcw-header">
      <span className="rcw-subtitle">{subtitle}</span>
      <h4 className="rcw-title">
        {headerAvatar && <img src={headerAvatar} className="avatar" alt="profile" />}
        {/* {title} */}
      </h4>
      {showCloseButton && !fullScreenMode ? (
        <button
          className="rcw-close-button"
          onClick={() => {
            if (window.parent && parentUrl) {
              window.parent.postMessage('isCloseButton', parentUrl);
            }
            toggleChat();
          }}
        >
          <img src={minus} className="rcw-close" alt="close" />
        </button>
      ) : (
        <div className="rcw-close-button-placeholder"></div>
      )}
    </div>
  ) : (
    <></>
  );
}

export default Header;
